import { render, staticRenderFns } from "./RegistrationRelationshipInformation.vue?vue&type=template&id=6b1380ba&scoped=true"
import script from "./RegistrationRelationshipInformation.vue?vue&type=script&lang=js"
export * from "./RegistrationRelationshipInformation.vue?vue&type=script&lang=js"
import style0 from "./RegistrationRelationshipInformation.vue?vue&type=style&index=0&id=6b1380ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1380ba",
  null
  
)

export default component.exports